import { isEmpty } from 'radash';
import { ProductResponse, RecipeRelateResponse, SearchResultResponse, TipsTricksWithCategoryResponse } from '@modules/libs/graphql/generated/graphql';
import { ISearchResultData, ISearchResultToDomain } from '@modules/search/domain/models/searchResult.model';
import { convertDate } from '@shared/utils/convertDate.utils';
export class SearchResultEntityMapper {
  public static toDomain(searchResultResponse: SearchResultResponse): ISearchResultToDomain {
    return {
      recipe: this.searchResultRecipeDataMapper(searchResultResponse.data.recipes),
      product: this.searchResultProductDataMapper(searchResultResponse.data.products),
      tipsAndTricks: this.searchResultTipsAndTricksDataMapper(searchResultResponse.data.tipsTricks),
      totalProducts: searchResultResponse.productTotal,
      totalRecipes: searchResultResponse.recipeTotal,
      totalTipsTricks: searchResultResponse.tipsTrickTotal
    };
  }
  private static searchResultRecipeDataMapper(searchResultRecipeData: RecipeRelateResponse[]): ISearchResultData[] {
    return searchResultRecipeData.map(data => {
      return {
        id: data.id.toString(),
        name: data.title,
        description: data.description,
        date: '',
        slug: isEmpty(data.slugUrl) ? data.id.toString() : data.slugUrl,
        viewer: 200000,
        imageUrl: data.thumbUrl,
        tag: data.recipeMeatCategory.map(({
          title
        }) => title),
        like: {
          isLiked: true,
          amount: 30
        }
      };
    });
  }
  private static searchResultProductDataMapper(searchResultProductDataMapper: ProductResponse[]): ISearchResultData[] {
    return searchResultProductDataMapper.map(data => {
      return {
        id: data.id.toString(),
        name: data.title,
        description: data.weight,
        date: '',
        slug: isEmpty(data.slugUrl) ? data.id.toString() : data.slugUrl,
        viewer: 200000,
        imageUrl: data.thumbUrl,
        tag: data.tag,
        like: {
          isLiked: true,
          amount: 30
        }
      };
    });
  }
  private static searchResultTipsAndTricksDataMapper(searchResultTipsAndTricksDataMapper: TipsTricksWithCategoryResponse[]): ISearchResultData[] {
    return searchResultTipsAndTricksDataMapper.map(data => {
      return {
        id: data.id.toString(),
        name: data.title,
        description: data.description,
        date: convertDate(data.publishedAt, 'th', 'DD MMM BBBB'),
        slug: data.slugUrl,
        viewer: 200000,
        imageUrl: data.thumbUrl,
        tag: data.category.length > 0 ? [data.category[0].title] : [],
        like: {
          isLiked: true,
          amount: 30
        }
      };
    });
  }
}